import { type SelectDataObject } from '../_tools/inputfields/Select';

const sStatusExport: SelectDataObject[] = [
    { i: 0, t: 'Keine Exportinformationen verfügbar', icon: 'mdi:help-circle', iconColor: 'text.disabled' },
    { i: 1, t: 'Export gesperrt | Zum Freigeben des Exports hier klicken{0}', icon: 'mdi:close', iconColor: 'error.main' },
    { i: 2, t: 'Export freigegeben | Zum Sperren des Exports hier klicken{0}', icon: 'mdi:check', iconColor: 'success.main' },
];
export default sStatusExport;
